import { createReducer } from '@reduxjs/toolkit';

import { dialogClosed } from 'Core/actions/dialog';
import { fitmentFieldsReducer } from 'Core/reducers/fitmentSearch/common';

const fieldsInitState = fitmentFieldsReducer.getInitialState();

export default createReducer(fieldsInitState, (builder) =>
  builder
    .addCase(dialogClosed, () => fieldsInitState)
    .addDefaultCase((state, action) => fitmentFieldsReducer(state, action)),
);
